var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '전자제조지원센터'
    }
  }), _c('div', {
    staticClass: "tab-list--primary-wrap"
  }, [_c('ul', {
    staticClass: "tab-list tab-list--primary"
  }, [_c('li', {
    staticClass: "on"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("센터개요")])], 1), _c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about/equipments"
    }
  }, [_vm._v("장비소개")])], 1), _c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about/location"
    }
  }, [_vm._v("오시는 길")])], 1)])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('section', {
    staticClass: "page-section"
  }, [_c('tit-primary', {
    attrs: {
      "sc": "용산전자제조지원센터 / KEA 가",
      "tit": "원효전자상가(용산)내 Y-밸리에서 전자제조를 지원합니다."
    }
  }), _c('div', {
    staticClass: "rounded mb-30 mb-lg-60"
  }, [_c('video', {
    staticClass: "w-100 d-block",
    attrs: {
      "controls": "",
      "preload": "none",
      "poster": "/images/sub/about/about-img.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "/res/video/1.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" Your browser does not support HTML5 video. ")])]), _c('div', {
    staticClass: "border-top border-2 border-color-black page-text color-grey"
  }, [_c('sub-list-primary', {
    attrs: {
      "tit": "소재지",
      "sc": "서울시 용산구 청파로77 원효전자상가 6동 3층",
      "spacing": "min-w-60px min-w-lg-80px mr-md-30 mr-xl-70"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "전용면적",
      "sc": "1,369㎡",
      "spacing": "min-w-60px min-w-lg-80px mr-md-30 mr-xl-70"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "공간구성",
      "sc": "교육장, 세미나룸, 회의룸, 동영상스튜디오, PC조립장, 오픈디버깅랩, AS룸, 라운지, 1인작업공간",
      "spacing": "min-w-60px min-w-lg-80px mr-md-30 mr-xl-70"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "주요장비",
      "sc": "전자부품실장라인, 보드조립라인(3개 제조라인), 모델링 지원장비(기구,외형), 전자제품 측정평가 및 실증장비 등",
      "spacing": "min-w-60px min-w-lg-80px mr-md-30 mr-xl-70"
    }
  })], 1)], 1), _c('section', {
    staticClass: "page-section"
  }, [_c('h4', {
    staticClass: "tit--sm bar-txt"
  }, [_vm._v(" 소형가전 제조지원 ")]), _c('div', {
    staticClass: "w-100 px-xl-32"
  }, [_c('v-row', {
    staticClass: "ma-xl-n34"
  }, [_c('v-col', {
    staticClass: "pa-xl-34",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('sub-icon-item-rounded', {
    attrs: {
      "bgColor": "#6f97f3",
      "icon": "/images/sub/about/about/s1-icon1.svg",
      "tit": "무게",
      "sc": "10kg 이하"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-xl-34",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('sub-icon-item-rounded', {
    attrs: {
      "bgColor": "#4377eb",
      "icon": "/images/sub/about/about/s1-icon2.svg",
      "tit": "크기",
      "sc": "30x30cm"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-xl-34",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('sub-icon-item-rounded', {
    attrs: {
      "bgColor": "#2e59b9",
      "icon": "/images/sub/about/about/s1-icon3.svg",
      "tit": "가격",
      "sc": "30만원"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-xl-34",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('sub-icon-item-rounded', {
    attrs: {
      "bgColor": "#6f97f3",
      "icon": "/images/sub/about/about/s1-icon4.svg",
      "tit": "교체주기",
      "sc": "2년이하"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-xl-34",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('sub-icon-item-rounded', {
    attrs: {
      "bgColor": "#4377eb",
      "icon": "/images/sub/about/about/s1-icon5.svg",
      "tit": "사용자반응 적용",
      "sc": "환류(재설계)"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-xl-34",
    attrs: {
      "cols": "6",
      "sm": "4",
      "md": "2"
    }
  }, [_c('sub-icon-item-rounded', {
    attrs: {
      "bgColor": "#2e59b9",
      "icon": "/images/sub/about/about/s1-icon6.svg",
      "tit": "중간기술 기반",
      "sc": "개발기간 6개월의 아이디어 소형가전"
    }
  })], 1)], 1)], 1)]), _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('div', {
    staticClass: "rounded border"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "h-100 pa-20 pa-md-30 px-lg-40 py-lg-50 border-bottom border-md-bottom-0 border-md-end",
    staticStyle: {
      "background-color": "#ebf5ff"
    }
  }, [_c('h4', {
    staticClass: "tit--sm font-weight-bold mb-20 mb-lg-34"
  }, [_vm._v(" KEA 전자제조센터 ")]), _c('v-row', {
    staticClass: "ma-n4 ma-md-n6"
  }, [_c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("1")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("운영사무실")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("2")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("강의실(교육)")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("3")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("회의룸")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("4")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("공동 AS실")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("5")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("세미나룸(고개실증)")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("6")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("스튜디오")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("7")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("제조장비룸")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("8")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("측정평가룸")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("9")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("오픈실험실(디버깅랩)")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("10")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("공동PC조립장")])]), _c('v-col', {
    staticClass: "pa-4 pa-md-6 d-flex align-center",
    attrs: {
      "cols": "auto",
      "md": "12"
    }
  }, [_c('span', {
    staticClass: "num mr-6 mr-lg-8 page-text--sm"
  }, [_vm._v("11")]), _c('p', {
    staticClass: "page-text color-grey"
  }, [_vm._v("1인작업공간")])])], 1)], 1)]), _c('v-col', {
    staticClass: "d-flex align-center justify-center pa-20 pa-md-30",
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "9"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/about/about/s1-img.jpg",
      "max-width": "818"
    }
  })], 1)], 1)], 1)])])], 1), _c('v-divider'), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit--lg font-weight-bold"
  }, [_vm._v(" 사업개요 ")])]), _c('div', {
    staticClass: "tabs-primary-wrap"
  }, [_c('v-tabs', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', [_vm._v("전자혁신 제조지원")]), _c('v-tab', [_vm._v("스마트전자 확산/제조실증 기반구축")]), _c('v-tab', [_vm._v("데이터분석기반 전자제조")])], 1)], 1), _c('v-tabs-items', {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', [_c('section', {
    staticClass: "page-section"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pr-md-12 pr-xl-60"
  }, [_c('div', {
    staticClass: "rounded w-100"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/about/about/s2-img1.jpg"
    }
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pt-md-12 pt-lg-24"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold mb-8 mb-lg-20"
  }, [_vm._v(" 전자혁신 제조지원 ")]), _c('h5', {
    staticClass: "tit-txt color-primary font-weghit-bold mb-20 mb-lg-54"
  }, [_vm._v(" 2021.4월 ~ 2023.12월 ")]), _c('div', {
    staticClass: "border-top border-2 border-color-black page-text color-grey"
  }, [_c('sub-list-primary', {
    attrs: {
      "tit": "지원내용",
      "sc": "빠른 제조, 부품지원, 상품화 등 전자제조서비스 지원",
      "spacing": "min-w-60px min-w-lg-80px mr-md-12 mr-xl-34"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "사업목표",
      "sc": "도심 내 전자혁신제조 플랫폼 구축으로 해외 이탈 전자 제조 수요를 국내로 복귀하여 전자제조 산업 르네상스 실현",
      "spacing": "min-w-60px min-w-lg-80px mr-md-12 mr-xl-34"
    }
  })], 1)])])], 1)], 1), _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('sub-text-card', {
    attrs: {
      "bgColor": "#2e59b9",
      "tit": "비전",
      "className": "mb-20 mb-lg-30"
    }
  }, [_c('span', {
    staticClass: "color-primary"
  }, [_vm._v("혁신제품 창출과 빠른지원을 통해 전자제조강국")]), _vm._v("에 기여한다. ")]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/about/about/arrow.svg",
      "max-width": "132"
    }
  }), _c('sub-text-card', {
    attrs: {
      "bgColor": "#4377eb",
      "tit": "목표",
      "className": "mt-n50 mt-lg-n36 position-relative"
    }
  }, [_c('span', {
    staticClass: "color-primary"
  }, [_vm._v("용산 [팩토리77] 구축을 통해 전자제조 집적화 확보")]), _vm._v(" 및 용산 전자 집적화를 통한 혁신제품 개발 생태계 확보 ")]), _c('div', {
    staticClass: "mt-50 mt-lg-220"
  }, [_c('sub-card-list', {
    attrs: {
      "tit": "전략",
      "className": "mb-20 mb-lg-60 position-relative"
    }
  }, [_c('v-row', {
    staticClass: "page-text font-weight-bold text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 뉴 트랜드 제품기반의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 빠른 생산 시스템 구축 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 도심 내 제조 생태계를 위한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 도시재생+산업재건 진행 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 빠른 디버깅이 가능한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 인력+장비 공간 구축 ")])])])], 1)], 1), _c('div', {
    staticClass: "arrow-image-wrap"
  }, [_c('v-img', {
    staticClass: "arrow-image mx-auto",
    attrs: {
      "src": "/images/sub/about/about/arrow.svg"
    }
  }), _c('sub-card-list', {
    staticClass: "arrow-wrap mt-n50 mt-lg-0 position-relative",
    attrs: {
      "tit": "구성"
    }
  }, [_c('v-row', {
    staticClass: "page-text font-weight-bold text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 빠른 제조를 통한 초도양산 지원 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 엔지니어 상주를 통한 직접 기술 지원 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" (언제니어+전문지원단) ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 개발자를 위한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 제조 지원 / 인프라 지원 ")])])])], 1)], 1)], 1)], 1)], 1)]), _c('v-tab-item', [_c('section', {
    staticClass: "page-section"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pr-md-12 pr-xl-60"
  }, [_c('div', {
    staticClass: "rounded w-100"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/about/about/s2-img2.jpg"
    }
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pt-md-12 pt-lg-24"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold mb-8 mb-lg-20"
  }, [_vm._v(" 스마트전자 확산, 제조실증 기반구축 ")]), _c('h5', {
    staticClass: "tit-txt color-primary font-weghit-bold mb-20 mb-lg-54"
  }, [_vm._v(" 2021.4월 ~ 2025.12월 ")]), _c('div', {
    staticClass: "border-top border-2 border-color-black page-text color-grey"
  }, [_c('sub-list-primary', {
    attrs: {
      "tit": "지원내용",
      "sc": "제품환류(제품 스케일업, 재설계 반복지원), 소비자실증 지원",
      "spacing": "min-w-60px min-w-lg-80px mr-md-12 mr-xl-34"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "사업목표",
      "sc": "전자제품의 스마트화, 소량제조, 환류, 유지보수를 지원할 수 있는 집적기반구축과 맞춤형 제조실증 지원을 통해 전자기업을 육성함",
      "spacing": "min-w-60px min-w-lg-80px mr-md-12 mr-xl-34"
    }
  })], 1)])])], 1)], 1), _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('sub-text-card', {
    attrs: {
      "bgColor": "#2e59b9",
      "tit": "비전",
      "className": "mb-20 mb-lg-30"
    }
  }, [_vm._v(" 누구나 쉽게 혁신하자 ")]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "src": "/images/sub/about/about/arrow.svg",
      "max-width": "132"
    }
  }), _c('sub-text-card', {
    attrs: {
      "bgColor": "#4377eb",
      "tit": "목표",
      "className": "mt-n50 mt-lg-n36 position-relative"
    }
  }, [_vm._v(" 용산 집적화를 통한 도심 전자생태계 확보 ")]), _c('div', {
    staticClass: "mt-50 mt-lg-220"
  }, [_c('sub-card-list', {
    attrs: {
      "tit": "전략",
      "className": "mb-20 mb-lg-60 position-relative"
    }
  }, [_c('v-row', {
    staticClass: "page-text font-weight-bold text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 제조, 개발자 제품의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 소비 트랜드 반영 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 도심내 설계, 조립, 유지보수 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 가능한 제조생태계 구축 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 소비자 실증 및 환류가 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 가능한 제조기반 구축 ")])])])], 1)], 1), _c('div', {
    staticClass: "arrow-image-wrap"
  }, [_c('v-img', {
    staticClass: "arrow-image mx-auto",
    attrs: {
      "src": "/images/sub/about/about/arrow.svg"
    }
  }), _c('sub-card-list', {
    staticClass: "arrow-wrap mt-n50 mt-lg-0 position-relative",
    attrs: {
      "tit": "구성"
    }
  }, [_c('v-row', {
    staticClass: "page-text font-weight-bold text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 고객반응 및 실증이 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 가능한 플렘폼 구축 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 스마트 제품의 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 조립, 제조, 실증 기반 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 전자개발, 제조기업을 위한 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 기술 집적지 구축 ")])])])], 1)], 1)], 1)], 1)], 1)]), _c('v-tab-item', [_c('section', {
    staticClass: "page-section"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-md-0",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pr-md-12 pr-xl-60"
  }, [_c('div', {
    staticClass: "rounded w-100"
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/sub/about/about/s2-img3-1.jpg"
    }
  })], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pt-md-12 pt-lg-24"
  }, [_c('h3', {
    staticClass: "tit font-weight-bold mb-8 mb-lg-20"
  }, [_vm._v(" 데이터분석기반 전자제조 전문인력양성 ")]), _c('h5', {
    staticClass: "tit-txt color-primary font-weghit-bold mb-20 mb-lg-54"
  }, [_vm._v(" 2021.3월 ~ 2026.2월 ")]), _c('div', {
    staticClass: "border-top border-2 border-color-black page-text color-grey"
  }, [_c('sub-list-primary', {
    attrs: {
      "tit": "지원내용",
      "sc": "단기집중교육운영, 데이터 활용이 가능한 전자제조전문인력(年30명) 배출",
      "spacing": "min-w-60px min-w-lg-80px mr-md-12 mr-xl-34"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "사업목표",
      "sc": "스마트전자 산업의 전자제조생태계 기반으로 현장중심의 데이터기반 전자제조 혁신 인재양성",
      "spacing": "min-w-60px min-w-lg-80px mr-md-12 mr-xl-34"
    }
  }), _c('sub-list-primary', {
    attrs: {
      "tit": "컨소시엄",
      "sc": "숭실대(전자), 숙명여대(경영분석), 서울과기대(데이터사이언스), KEA(제조/장비)",
      "spacing": "min-w-60px min-w-lg-80px mr-md-12 mr-xl-34"
    }
  })], 1)])])], 1)], 1), _c('section', {
    staticClass: "page-section page-section--last"
  }, [_c('sub-text-card', {
    attrs: {
      "bgColor": "#2e59b9",
      "tit": "추진목표"
    }
  }, [_vm._v(" 용산 전자지구의 제조장비, 생태계, 고객데이터를 활용한 교육프로그램 운영을 통해 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 전자+제조+데이터+경영에 대한 이해도가 높은 산업혁신인재 양성 ")]), _c('div', {
    staticClass: "mt-50 mt-lg-220"
  }, [_c('sub-card-list', {
    attrs: {
      "tit": "추진전략",
      "className": "mb-20 mb-lg-60 position-relative"
    }
  }, [_c('v-row', {
    staticClass: "page-text font-weight-bold text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 용산 전자지구 기반 현장교육 (전자특화지역) ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 제조장비를 통한 전주기 교육 (Y-Factory77+용산상상가) ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 대학별 특화 및 유기적 협력을 통한 융합교육 ")])])]), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "card card--shadow h-100 d-flex align-center justify-center"
  }, [_c('p', [_vm._v(" 산학 프로젝트 및 제품 데이터 분석을 통한 전문가 양성 ")])])])], 1)], 1), _c('div', {
    staticClass: "arrow-image-wrap"
  }, [_c('v-img', {
    staticClass: "arrow-image mx-auto",
    attrs: {
      "src": "/images/sub/about/about/arrow.svg"
    }
  }), _c('sub-card-list', {
    staticClass: "arrow-wrap mt-n50 mt-lg-0 position-relative",
    attrs: {
      "tit": "추진방안"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto w-100 mb-8 mb-lg-20",
    attrs: {
      "src": "/images/sub/about/about/s2-img3-2.jpg",
      "max-width": "933"
    }
  }), _c('h5', {
    staticClass: "tit-txt font-weight-bold text-center"
  }, [_vm._v(" 특화 집중교육 / 장비기반교육 / 지역산업교육 / 교육과정지역 신설 / 대학별 협력 / 취업 활성화 ")])], 1)], 1)], 1)], 1)])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }